import React from 'react';
import styled, { css } from 'astroturf/react';
import { CreateSocialItem } from './CreateSocialItem';
import { User } from 'js/social/UserCard';
import {
  OpenalexWork,
  Paper,
  ResourcePayload,
  Tag,
  FollowableUser,
} from 'js/social/shared/types';
import { AuthorAvatar, AuthorHeader } from '../News/AuthorHeader';
import { SocialEditor } from 'js/social/shared/SocialEditor/SocialEditor';
import PaperAbstract from '../PaperAbstract';
import { ImpressionPropsGenerator } from 'js/social/ImpressionHelper';

const CommentModalContentWrapper = styled.div`
  margin-top: 8px;
`;

const CommentModalPaperCardWrapper = styled.div`
  margin-top: 16px;
  border-radius: var(--border-radius-radius-md);
  overflow: hidden;
`;

const PostContentClassname = css`
  @import 'stylesheets/design_system/font.scss';
  @include body__medium;
`;

type ReplyToUser = {
  kind: 'user';
  user: FollowableUser;
  timestamp: string;
};

type ReplyToRecommendation = {
  kind: 'recommendation';
  recommendation: {
    name: string;
    subtitle: string;
  };
};

export type CommentReplyTo = ReplyToUser | ReplyToRecommendation;

export const CreateComment = ({
  newsId,
  author,
  replyTo,
  replyToContent,
  replyToWork,
  onClose,
  onSubmit,
  impressionPropsGen,
}: {
  newsId: string | number;
  author: User;

  replyTo: CommentReplyTo;
  replyToContent?: {
    content: string;
    tags: Tag[];
  };
  replyToWork?: Paper | OpenalexWork;

  onClose(): void;
  onSubmit(payload: ResourcePayload): void;
  impressionPropsGen: ImpressionPropsGenerator;
}) => {
  return (
    <CreateSocialItem
      id={`comment-${newsId}`}
      author={author}
      replyTo={{
        node: (
          <>
            {replyTo.kind === 'user' ? (
              <AuthorHeader
                kind="user"
                user={replyTo.user}
                size="md"
                timestamp={replyTo.timestamp}
                showTimestamp={false}
                showAvatar={false}
                impressionPropsGen={impressionPropsGen}
              />
            ) : (
              <AuthorHeader
                kind="recommendation"
                recommendation={replyTo.recommendation}
                showAvatar={false}
                size="md"
                impressionPropsGen={impressionPropsGen}
              />
            )}
            {replyToContent && (
              <CommentModalContentWrapper>
                <SocialEditor
                  containerClassName={PostContentClassname}
                  content={replyToContent.content}
                  tags={replyToContent.tags}
                  readOnly
                  collapsible
                  lines={2}
                  lineHeight={20}
                />
              </CommentModalContentWrapper>
            )}
            {replyToWork && (
              <CommentModalPaperCardWrapper>
                <PaperAbstract
                  work={replyToWork}
                  canUseReader={false}
                  showReader={() => {}}
                  impressionPropsGen={impressionPropsGen()()}
                  paperInteractions={null}
                  size="sm"
                  showSummary={false}
                />
              </CommentModalPaperCardWrapper>
            )}
          </>
        ),
        profileImg:
          replyTo.kind === 'user' ? (
            <AuthorAvatar kind="user" user={replyTo.user} size="md" />
          ) : (
            <AuthorAvatar kind="recommendation" size="md" />
          ),
      }}
      placeholder="Post your reply..."
      submitButtonText="Reply"
      allowAttachments={false}
      onClose={onClose}
      onSubmit={onSubmit}
      impressionPropsGen={impressionPropsGen()('comment-modal')}
    />
  );
};
